import { contains } from '@zambezi/sdk/common'

export function focus (labelElementRef, elementRef, setFocused, focusOptions) {
  const { current: labelElement } = labelElementRef
  const { current: element } = elementRef
  if (
    !labelElement ||
    !contains(labelElement.parentNode, document.activeElement)
  ) {
    element && element.focus(focusOptions)
    setFocused(true)
  }
}

export function componentWillReceiveProps (
  props,
  propsChecked,
  propsId,
  id,
  globalId,
  isUncontrolled,
  setChecked,
  setId
) {
  if (!isUncontrolled(props)) {
    setChecked(propsChecked)
  }
  if (propsId !== id) {
    setId(propsId || globalId)
  }
}
